var React = require('react');

function ShapeGroup6 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.7","d":"M900.026 375.476C900.026 375.476 1028.27 931.819 797.051 1098.62C574.684 1259.04 102.289 999.689 102.289 999.689C102.289 999.689 -25.9531 443.347 205.263 276.543C427.631 116.124 900.026 375.476 900.026 375.476Z","fill":"#BEE2F1","key":0}),React.createElement("path",{"opacity":"0.7","d":"M1126.64 120.027C1126.64 120.027 1205.38 461.636 1063.41 564.057C926.87 662.559 636.808 503.31 636.808 503.31C636.808 503.31 558.064 161.701 700.037 59.28C836.576 -39.2217 1126.64 120.027 1126.64 120.027Z","fill":"#EFA891","key":1})]);
}

ShapeGroup6.defaultProps = {"width":"1190","height":"1196","viewBox":"0 0 1190 1196","fill":"none"};

module.exports = ShapeGroup6;

ShapeGroup6.default = ShapeGroup6;
